import { computed, ComputedRef } from "vue";
import { useStore } from "vuex";
import { ProductVersion } from "@/apps/merchant3/types/ProductVersion";

type ComposableResult = {
  productVersion: ComputedRef<string | null>;
  isSelfService: ComputedRef<boolean>;
};

export function useProductVersion(): ComposableResult {
  const store = useStore();
  const productVersion = computed(
    () => store.state.carts?.productVersion ?? null
  );

  const isSelfService = computed(
    () =>
      store.state.carts?.productVersion === ProductVersion.M3_SELF_ONBOARDING
  );

  return {
    productVersion,
    isSelfService,
  };
}
